// extracted by mini-css-extract-plugin
module.exports = {"pinTopItem":"styles_pinTopItem__3h0oX","pinBottomItem":"styles_pinBottomItem__06El_"};